import { render } from "./FollowerList.vue?vue&type=template&id=090a3b1c&scoped=true"
import script from "./FollowerList.vue?vue&type=script&lang=js"
export * from "./FollowerList.vue?vue&type=script&lang=js"

import "./FollowerList.vue?vue&type=style&index=0&id=090a3b1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090a3b1c"]])

export default __exports__